import { Outlet } from "react-router-dom";
import Footer from "./Main/Footer";
import Header from "./Main/Header";
import Snowfall from "./Main/Snow";

const Layout = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Snowfall />
      <Header />
      <main className="flex-grow-1" style={{ flex: 1 }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
